import WTGRegistrationForm from 'main/components/WTGRegistrationForm'
import React from 'react'

export default function WTGCreatorForm() {
  return (
    <main className='min-h-[66vh] wtg-scrollbar'>
      <WTGRegistrationForm />
    </main>
  )
}